import { useMemo } from "react";

import { ORDERBOOKS_POLLING_INTERVAL } from "~/v2/constants";
import { queryKeys } from "../queryKeys";
import { getOrderbooks } from "../rest/data";
import { useRequest } from ".";

export const useGetOrderbooks = ({ symbols }: { symbols: string[] }) => {
  const sortedSymbols = useMemo(() => [...symbols].sort(), [symbols]);
  const { data } = useRequest(
    queryKeys.orderbooks(sortedSymbols),
    () => getOrderbooks(sortedSymbols),
    {
      staleTime: ORDERBOOKS_POLLING_INTERVAL,
      refetchInterval: ORDERBOOKS_POLLING_INTERVAL,
    },
  );
  return { orderbooks: data?.orderbooks };
};

export default useGetOrderbooks;
